// Libraries.
import { useDispatch, useSelector } from "react-redux";
// Store.
import { RootState } from "../../store/store";
// Slice.
import { closeModal } from "./modalSlice";
// Components
import Modal from "../../components/Modal";
import Form from "../../components/Form";

export const ContactModalForm: React.FC = () => {
  const isOpen = useSelector((state: RootState) => state.modal.isOpen);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(closeModal());
  };

  return (
    <Modal className={"modal-contact"} isOpen={isOpen} onClose={handleClose}>
      <Form className="contact-form">
        <h2>Contacto</h2>
        <input type="text" placeholder="Nombre" required />
        <input type="email" placeholder="Correo Electrónico" required />
        <input type="tel" placeholder="WhatsApp" required />
        <textarea placeholder="Mensaje" required></textarea>
        <button type="submit">Enviar</button>
      </Form>
    </Modal>
  );
};
